export class StringResources {
    static custom = {
        loadingReport: 'Report starting...',
        loadingReportPagesInProgress: 'Report loading in progress...',
        // override other string resources here
    }
}